import { useMutation, useQueryClient } from 'react-query';
import notify from '../../../../../../../shared/feedback/notifications';
import { handleError } from '../../../../../../../shared/ErrorCatching';
import { Translate } from '../../../../../../../shared/LanguageService';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import {
    ImageProcessingComments,
    imageProcessingCommentsQueryKey
} from './use-query-image-processing-comments';

type UpdateCommentMutationArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

export type UpdateCommentInput = {
    text: string;
    type: number;
};

export function useUpdateCommentMutation({ orderId, user }: UpdateCommentMutationArgs) {
    let queryClient = useQueryClient();
    let { logger } = useTelemetryContext();

    return useMutation(
        ({ text, type }: UpdateCommentInput): Promise<ImageProcessingComments> =>
            ImageProcessingApi.updateImageProcessingComment(orderId, text, type),
        {
            onSuccess: (comments) => {
                queryClient.setQueryData([imageProcessingCommentsQueryKey, { orderId }], comments);
                notify.success(Translate('image-processing/notification/comment-updated'));
            },
            onError: (error) => {
                logger.logException(error, {
                    origin: 'ImageEditorImageProcessingPage.Mutation.updateImageProcessingComment',
                    userInfo: getUserInfo(user)
                });
                handleError(error);
            }
        }
    );
}
